// NB: [id, name (English), selfTestCategoryId]
export type SelfTestOption = [number, string, number];

export const selfTests: SelfTestOption[] = [
  [1, 'Display', 1],
  [2, 'Buzzer', 5],
  [3, 'Speaker', 5],
  [4, 'Microphone', 5],
  [5, 'Touchscreen', 1],
  [6, 'Backlight', 1],
  [7, 'Light Sensor', 1],
  [8, 'RTC', 2],
  [9, 'GPS', 3],
  [10, 'V2V', 4],
  [11, 'GSM', 11],
  [12, 'WIFI', 11],
  [13, 'STM32', 2],
  [14, 'IVU Temperature', 2],
  [15, 'IMX Temperature', 2],
  [16, 'Display Temperature', 1],
  [17, 'IVU 3V2', 2],
  [18, 'IVU 3V8', 2],
  [19, 'IVU MODEM3V2', 2],
  [20, 'IVU 5V0', 2],
  [21, 'IVU 12V0', 2],
  [22, 'IVU Input Voltage', 2],
  [23, 'IVU Input Current', 2],
  [24, 'IVU Output Voltage', 2],
  [25, 'Display 3V3', 1],
  [26, 'Display 5V0', 1],
  [27, 'Display 24V0', 1],
  [28, 'Digital Input 1', 2],
  [29, 'Digital Input 2', 2],
  [30, 'Digital Input 3', 2],
  [31, 'Digital Input 4', 2],
  [32, 'Digital Output 1', 2],
  [33, 'Digital Output 2', 2],
  [34, 'Internal Flash', 7],
  [35, 'SD Card', 7],
  [36, 'RAM', 7],
  [37, 'Database', 7],
  [38, 'CAS Web', 11],
  [39, 'CAS Bus', 8],
  [40, 'CAS CAM', 8],
  [41, 'Expansion', 8],
  [42, 'Primary GPS', 3],
  [43, 'Second GPS', 3],
  [44, 'Node Communications', 6],
  [45, 'CAN Bus', 6],
  [46, 'Rear LFM Communications', 9],
  [47, 'Rear LFM Emitter', 9],
  [48, 'Primary Node Communications', 6],
  [49, 'UHF Radio', 3],
  [50, 'Front LFM Communications', 9],
  [51, 'Front LFM Emitter', 9],
  [52, 'Shared Memory', 7],
  [53, 'Input Ignition', 10],
  [54, 'Input Forward', 10],
  [55, 'Input Reverse', 10],
  [56, 'TOF Rear', 8],
  [57, 'TOF Front', 8],
  [58, 'TOF Left', 8],
  [59, 'TOF Right', 8],
  [60, 'Base Machine Status', 13],
  [61, 'GPS or TOF', 3],
  [62, 'Heading', 3],
  [63, 'Bluetooth', 6],
  [64, 'GSM or WIFI', 11],
  [65, 'Interaction Config File', 12],
  [66, 'Input vs Movement', 10],
  [67, 'PCU Comms', 6],
  [68, 'Audio Test', 5],
  [70, 'V2X', 4],
  [71, 'CASInstaller Config File', 12],
  [72, 'CAS Config File', 12],
  [73, 'CASCAMRF Config File', 12],
  [74, 'CASLogger Config File', 12],
  [75, 'GeoFence Config File', 12],
  [76, 'ERS Config File', 12],
  [77, 'Download Config File', 12],
  [78, 'Shell Config File', 12],
  [79, 'Intervention Init', 13],
  [80, 'Intervention Negotation', 13],
  [81, 'Intervention Confirmation', 13],
  [82, 'Intervention Heart Beat', 13],
  [83, 'Intervention Interface Data', 13],
  [84, 'Intervention Interface Date Time', 13],
  [85, 'Intervention Error Reply', 13],
  [86, 'Site-Config XML File', 12],
  [87, 'Intervention Analysis Disabled', 13],
];
